<template>
    <mercur-card class="card">
        <h4 v-if="title">{{title}}</h4>
        <form @submit.prevent="save">
            <mercur-input type="number" v-model="printrun" required>Printrun</mercur-input>
            <mercur-button class="btn btn-raised" type="submit">Save</mercur-button>
        </form>
    </mercur-card>
</template>
<script>
import CONFIG from '@root/config'

export default {
    name: 'CatalogProductIdealPathSection',
    props: {
        title: {
            default: null,
            type: String,
        },
        catalogProductId: {
            type: String,
            required: true,
        },
    },
    data () {
        return {
            printrun: null,
        }
    },
    methods: {
        save () {
            let url = CONFIG.API.ROUTES.CATALOG.SET_CATALOG_PRODUCT_IDEAL_PATH
            let payload = { printrun: Number.parseInt(this.printrun, 10), catalogProductId: this.catalogProductId }
            this.post(url, payload, 'Successfully saved', 'Something went wrong. Please try again.')
        },
        fetch () {
            let url = CONFIG.API.ROUTES.CATALOG.VARIANTS.PRODUCT_SETTINGS.LIST.replace('{productVariantId}', this.catalogProductId)
            let payload = {
                'startRow': 0,
                'endRow': 10,
                'filterModel': {
                    'type': {
                        'type': 'equals',
                        'filter': 'ideal_path',
                        'filterType': 'text',
                    },
                },
            }
            this.post(url, { request: payload }).then((response) => {
                this.printrun = (
                    response.data &&
                    response.data[0] &&
                    response.data[0].configuration &&
                    response.data[0].configuration.printrun
                ) || null
            })
        },
    },
    mounted () {
        this.fetch()
    },
}
</script>
